import Transformer from './../transformer'

export default class CustomerStaffTransformer extends Transformer {
  static fetch(staff) {
    let typeStaff = staff.type_staff
    typeStaff = {
      id: typeStaff.type_staff_id,
      name: typeStaff.type_staff_name,
    }
    return {
      id: staff.id,
      name: staff.name,
      lastName: staff.last_name,
      mothersLastName: staff.mothers_last_name,
      title: staff.title,
      customer: staff.customer,
      customerId: staff.customer.id,
      typeStaff,
      typeStaffId: typeStaff.id,
      typeStaffName: typeStaff.name,
      email: staff.email,
      phone: staff.phone,
      phoneExt: staff.phone_ext,
      cellphone: staff.cellphone
    }
  }

  static send(staff) {
    return {
      id: staff.id,
      name: staff.name,
      last_name: staff.lastName,
      mothers_last_name: staff.mothersLastName,
      title: staff.title,
      customer: staff.customerId,
      // position: staff.position,
      type_staff: staff.typeStaffId,
      email: staff.email,
      phone: staff.phone,
      phone_ext: staff.phoneExt,
      cellphone: staff.cellphone
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/customerStaff.js